<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #FFF6E5; height:100% ">
        <v-toolbar class="slide-card-up mb-8" dense :color="miColorNaranja" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo2.png" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        
        <v-row dense class="slide-card-up" justify="center">
            <h1 v-if="camino != null" class="mt-0 ma-4 mr-12">{{ $t('mensajes.inicial') }} {{ esAgencia ?
                this.agencia.nombre : '' }}</h1>
        </v-row>
        <v-row v-if="camino != null" dense class="slide-card-up">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    {{ $t('mensajes.descripcion') }}
                </p>
            </v-col>
        </v-row>

        <v-container>
          

            <v-row justify="center">
                <v-col align="center">
                    
                    <!-- Formulario de Pasajeros -->
                    <v-card v-if="step != 4" class="mx-4 pa-4 card-personalizada slide-card"
                        style="min-width: 500px; width: 500px;">
                        <v-card-title>
                        </v-card-title>
                        <v-card-text>
                            <v-row class="mt-0 mb-2">
                                <v-col justify="start">
                                    <p class="mx-0">
                                        Para confirmar la reserva necesitamos rellene los datos principales de todos los
                                        datos de los
                                        pasajeros.
                                    </p>
                                </v-col>
                            </v-row>

                            <div v-for="(pasajero, index) in pasajeros" :key="index">

                                <v-row class="mt-0 mb-2">
                                    <v-col justify="start">
                                        <h2 class="mx-0">
                                            Pasajero {{ index + 1 }}
                                        </h2>
                                    </v-col>
                                </v-row>

                                <v-row dense class="mx-2 mb-4">
                                    <v-text-field v-model="pasajero.nombre" class="mx-4 mb-2" label="Nombre" type="text"
                                        outlined dense autocomplete="off" hide-details>
                                    </v-text-field>
                                </v-row>

                                <v-row dense class="mx-2 mb-4">
                                    <v-text-field v-model="pasajero.primer_apellido" class="mx-4 mb-2" label="Apellidos"
                                        type="text" outlined dense autocomplete="off" hide-details>
                                    </v-text-field>
                                </v-row>

                                <v-row dense class="mx-2 mb-4">
                                    <v-col cols="5" class="pr-0">
                                        <v-select v-model="pasajero.tipo_documento" :items="tipoDeDocumentos"
                                            item-text="name" item-value="value" outlined dense hide-details
                                            class="mx-4">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="7" class="pl-0">
                                        <v-text-field v-model="pasajero.documento" class="mx-4 mb-2" label="Documento"
                                            :error="!isValidDocument(pasajero.tipo_documento, pasajero.documento)"
                                            type="text" outlined dense autocomplete="off" hide-details
                                            @input="pasajero.documento = $event.toUpperCase()">
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-divider class="mb-4"></v-divider>

                            </div>





                        </v-card-text>
                    </v-card>
                </v-col>
              
                <!-- Ticket de Compra cuando es Agencia -->
                <v-col v-if="modelReserva.id != null && step != 4" align="center">
                    <v-card class="mx-4 card-personalizada slide-card"
                        style="background-color: #DDFFDD; min-width: 500px; width: 500px;">
                        <v-card-title style="background-color: #DDFFDD; text-align: center;">
                            <h1 style="font-size: 1.2rem;" class="mx-4">
                                {{ $t('mensajes.datos_reserva.titulo') + ': ' + modelReserva.codigo}}
                            </h1>
                        </v-card-title>
                        <v-card-text>
                            <v-row dense>

                                <v-col align="center">
                                    <h3> {{ getTituloCamino(modelReserva.camino) }}
                                    </h3>
                                </v-col>
                            </v-row>
                            <v-row dense v-if="modelReserva.fecha_inicio">
                                <v-col cols="6" align="end">
                                    {{ $t('mensajes.datos_reserva.fecha_inicio') }}
                                </v-col>
                                <v-col align="start">
                                    {{ this.modelReserva.fecha_inicio }}
                                </v-col>
                            </v-row>
                            <v-row dense v-if="modelReserva.fecha_llegada">
                                <v-col cols="6" align="end">
                                    {{ $t('mensajes.datos_reserva.fecha_llegada') }}
                                </v-col>
                                <v-col align="start">
                                    {{ this.modelReserva.fecha_llegada }}
                                </v-col>
                            </v-row>

                            <v-row class="mt-4" dense>
                                <v-col cols="4" align="end">
                                    {{ $t('mensajes.datos_reserva.habitaciones') }}
                                </v-col>
                                <v-col align="start">
                                    {{ this.modelReserva.cant_habitaciones_individuales +
                                        this.modelReserva.cant_habitaciones_dobles +
                                        this.modelReserva.cant_habitaciones_triples }}
                                    ( {{ this.modelReserva.cant_habitaciones_individuales ?
                                        this.modelReserva.cant_habitaciones_individuales +
                                        (this.$i18n.locale === 'de' ? ' Einzelzimmer' :
                                            this.$i18n.locale === 'en' ? ' single ' :
                                                ' individuales') : '' }} {{
                                        this.modelReserva.cant_habitaciones_dobles ?
                                            this.modelReserva.cant_habitaciones_dobles +
                                            (this.$i18n.locale === 'es' ? ' dobles (2 camas Ind) ' :
                                                this.$i18n.locale === 'de' ? ' Doppelzimmer (2 Einzelbetten)' :
                                                    this.$i18n.locale === 'en' ? ' double room (2 single beds)' :
                                                        ' dobles (2 camas Ind)')
                                            : '' }}
                                    {{
                                        this.modelReserva.cant_habitaciones_dobles_matrimoniales ?
                                            this.modelReserva.cant_habitaciones_dobles_matrimoniales +
                                            (this.$i18n.locale === 'es' ? ' dobles (cama matrimonial) ' :
                                                this.$i18n.locale === 'de' ? ' Doppelzimmer (1 Doppelbett)' :
                                                    this.$i18n.locale === 'en' ? ' double room (1 double bed)' :
                                                        ' dobles (cama matrimonial)')
                                            : '' }} {{ this.modelReserva.cant_habitaciones_triples ?
                                        this.modelReserva.cant_habitaciones_triples
                                        + (this.$i18n.locale === 'es' ? ' triples ' :
                                            this.$i18n.locale === 'de' ? ' Dreibettzimmer' :
                                                this.$i18n.locale === 'en' ? ' triple' :
                                                    ' triples')
                                        : '' }})
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="4" align="end">
                                    {{ $t('mensajes.datos_reserva.peregrinos') }}
                                </v-col>
                                <v-col align="start">
                                    {{ this.modelReserva.cant_peregrinos }}
                                </v-col>
                            </v-row>

                            <v-row dense class="mt-6">
                                <v-col cols="8" align="end">
                                    <h3> {{ $t('mensajes.datos_reserva.importe_reserva') }} (PVP) </h3>
                                </v-col>
                                <v-col align="end">
                                    <h2>{{ importeReserva }} €</h2>
                                </v-col>
                            </v-row>
                            <v-row dense class="mt-0">
                                <v-col cols="8" align="end">
                                    <h4> 15% Comisión Agencia </h4>
                                </v-col>
                                <v-col align="end">
                                    <h3>{{ importeComision }} €</h3>
                                </v-col>
                            </v-row>
                            <v-row dense class="mt-0">
                                <v-col cols="8" align="end">
                                    <h4> Importe Neto Agencia </h4>
                                </v-col>
                                <v-col align="end">
                                    <h3>{{ importeNeto }} €</h3>
                                </v-col>
                            </v-row>
                            <v-row dense class="mt-2">
                                <v-col align="end">
                                    <p v-html="descripcionImporteReserva" />
                                </v-col>
                            </v-row>

                            <v-row >
                                <v-col cols="8" align="end">
                                    <h3 class="mb-0"> {{ $t('mensajes.datos_reserva.servicios_agregados') }} (Neto)
                                    </h3>
                                    <span class="mt-0" style="font-size: 0.8rem;"> {{
                                        $t('mensajes.datos_reserva.no_comisionable') }}
                                    </span>
                                </v-col>
                                <v-col align="end">
                                    <h2>{{ importeServicios }} €</h2>
                                </v-col>
                            </v-row>

                            <v-row align="center" dense >

                                <v-col align="end">
                                    <p v-html="descripcionImporteServicios" />
                                </v-col>

                                <!--    <v-col v-if="servicio.titulo !== 'Noche extra' && servicio.seleccionado" cols="8" align="end">
                                    {{ getTituloServicio(servicio) }}
                                    <br>
                                    {{ _getSubtituloServicioWithPersona(servicio) }}
                                </v-col>
                                <v-col v-if="servicio.titulo !== 'Noche extra' && servicio.seleccionado" align="end">
                                    <span>{{ _calcularTarifaDeServicioWithPersona(servicio) == 0 ? ' - ' :
                                        _calcularTarifaDeServicioWithPersona(servicio) }}
                                        €</span>
                                </v-col>

                                <v-row class="mt-2" dense v-if="servicio.titulo == 'Noche extra' && servicio.seleccionado" v-for="noche in nochesextras" :key="noche.id">
                                    <v-col align="end">
                                        Noche extra en {{ noche.localidad }}..... - €
                                    </v-col>
                                </v-row>
                            -->



                            </v-row>

                            <v-row class="mt-6" dense >
                                <v-col cols="8" align="end">
                                    <h3> {{ $t('mensajes.datos_reserva.importe_total') }} (PVP) </h3>
                                </v-col>
                                <v-col align="end">
                                    <h2>{{ importeTotal }} €</h2>
                                </v-col>
                            </v-row>
                            <v-row dense >
                                <v-col cols="8" align="end">
                                    <h3> {{ $t('mensajes.datos_reserva.importe_total') }} (Neto) </h3>
                                </v-col>
                                <v-col align="end">
                                    <h3>{{ importeTotalNeto }} €</h3>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                  
                  

                    <v-row justify="center" class="mt-4">
                        <v-chip link large @click="_enviarConfirmacionReserva()" class="ma-2 px-8 mr-8"
                            :class="{ 'hover-color': datosPasajerosCompletados }"
                            :color="!datosPasajerosCompletados ? 'grey' : (step >= 1 ? miColorAzul : miColorNaranja)"
                            :text-color="!datosPasajerosCompletados ? 'black' : (step >= 1 ? miColorNaranja : miColorAzul)"
                            style="font-size: 1.2rem;" :disabled="!datosPasajerosCompletados">
                            Enviar Confirmación de Reserva
                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                        </v-chip>
                    </v-row>
                </v-col>
            </v-row>


            <!-- Step 4: Envío del presupuesto -->
            <v-row v-if="step === 4" justify="center" class="mt-12">
                <v-col cols="12" sm="8" md="6" class="text-center">
                    <!-- Enviando presupuesto -->
                    <v-card v-if="loadingEnviandoPresupuesto" class="pa-6 card-personalizada slide-card">
                        <div class="mt-4 flying-document-container">
                            <v-icon class="flying-document" :color="miColorNaranja"
                                size="64">mdi-file-document-outline</v-icon>
                            <div class="wind-line wind-line-1"></div>
                            <div class="wind-line wind-line-2"></div>
                            <div class="wind-line wind-line-3"></div>
                        </div>
                        <div class="mt-4 pulse-text">
                            <h2 :style="{ color: miColorAzul }">{{ 'Enviando Confirmación' }}</h2>
                        </div>
                    </v-card>
                    <!-- Card Final Presupuesto enviado -->
                    <v-card v-else class="pa-6 card-personalizada slide-card">
                        <v-card-text>
                            <v-row justify="center" class="mb-4">
                                <h1> {{ 'Confirmación enviada' }}</h1>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Card Resumen Presupuesto -->
                    <v-card v-if="this.camino && !loadingEnviandoPresupuesto"
                        class="mt-6 pa-6 card-personalizada slide-card">
                        <v-card-text>
                            <v-row justify="center" class="mb-4">
                                <v-col cols="4" align="center">
                                    <v-img v-if="this.camino.etapas[0].imagen_base64"
                                        :src="this.camino.etapas[0].imagen_base64" width="200px" height="200px"
                                        style="border-radius: 20px;"></v-img>
                                </v-col>
                                <v-col align="start">
                                    <p>
                                        {{ this.language == 'en' ? this.camino.resumen_EN :
                                            this.language == 'de' ? this.camino.resumen_DE :
                                                this.camino.resumen }}
                                    </p>


                                </v-col>
                            </v-row>

                            <v-row class="mt-4 mb-2" justify="end">
                                <v-chip link @click="_irAWebAlCamino()" large class="ma-2 px-8 mr-8 hover-color"
                                    :color="step >= 1 ? miColorAzul : miColorNaranja"
                                    :text-color="step >= 1 ? miColorNaranja : miColorAzul" style="font-size: 1.2rem;">
                                    {{ $t('mensajes.ir_al_camino') }}
                                    <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                </v-chip>
                            </v-row>
                        </v-card-text>
                    </v-card>


                </v-col>
            </v-row>

        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            language: 'es',
            step: 1,
            admin: false,
            serviciosNoIncluidos: [],

            loadingEnviandoPresupuesto: false,

            tipoDeDocumentos: [
                { name: 'DNI', value: 'DNI' },
                { name: 'NIE', value: 'NIE' },
                { name: 'PASAPORTE', value: 'PASAPORTE' },
            ],

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorAmarillo: '#FFF6E5',
            showFechaInicio: false,
            showFechaFinal: false,
            comentarios: '',
            importe_presupuestado: 0,
            descripcionImporteReserva: '',
            descripcionImporteServicios: '',

            modelReserva: {
                id: null,
                codigo: null,
                camino: null, 
                fecha_inicio: null,
                fecha_llegada: null,
                cant_peregrinos: 0,
                cant_habitaciones_individuales: 0,
                cant_habitaciones_dobles: 0,
                cant_habitaciones_dobles_matrimoniales: 0,
                cant_habitaciones_triples: 0,
                importe_presupuestado: 0,
                importe_reserva: 0,
                importe_servicios: 0,
                descripcion_importe_presupuestado: '',
                descripcion_importe_reserva: '',
                descripcion_importe_servicios: '',
                tarifa_nocheextra_ind: null,
                tarifa_nocheextra_doble: null,
                tarifa_nocheextra_triple: null,
                desgloce_nochesextras: false,
                origen_id: 1,
                tienePendientes: false,
                cliente: {
                    nombre: '',
                    apellidos: '',
                    telefono: '',
                    email: '',
                    aceptaPolitica: true,
                    aceptaNovedades: false
                }
            },

            pasajeros: [],
            nochesextras: [],
            trasladosExtras: [],
            serviciosExtras: [],

            codigoPaisSeleccionado: null,

            precio_ind: 0,
            precio_doble: 0,
            precio_triple: 0


        };
    },
    computed: {
        ...mapState("caminos", ["camino", "agencia"]),
        ...mapGetters('paises', ['getCodigosPais']),

        codigosPais() {
            return this.getCodigosPais;
        },

        datosPasajerosCompletados() {
            return this.step === 5 && this.pasajeros.every(pasajero => pasajero.nombre && pasajero.primer_apellido && pasajero.documento && pasajero.tipo_documento);
        },

        esAgencia() {
            return this.agencia != null && this.agencia.id != 1;
        },

        serviciosIncluidos() {
            if (this.camino) {
                return this.camino.servicios.filter(servicio => servicio.esta_habilitado && servicio.esta_incluido);
            }
            return [];
        },

        datosMinimosCompletados() {
            if (this.camino) {
                if (this.step === 1 || this.step === 2 || this.step === 3 || this.step === 5) {
                    return this.modelReserva.cant_peregrinos > 0 && this.modelReserva.fecha_inicio && (this.modelReserva.cant_habitaciones_individuales > 0 || this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 || this.modelReserva.cant_habitaciones_triples > 0);
                } /*else if (this.step === 4) {
                    return this.modelReserva.cliente.nombre && this.modelReserva.cliente.email;
                }*/ else if (this.step === 4) {
                    return true;
                }
            }
            return false;
        },

        importeReserva() {
            return this.modelReserva.id != null ? this.modelReserva.importe_reserva : 0 ;
           

            const tarifaActual = this.obtenerTarifaActual();
            const suplemento = this.obtenerSuplementoTarifa(tarifaActual);
            const factorSuplemento = 1 + (suplemento / 100);
            let nochesConSuplemento = this.calcularNochesConSuplemento(tarifaActual);
            let nochesTotales = this.calcularNochesTotales();

            let importeTotal = 0;
            let descripcion = '';

            if (!suplemento || nochesConSuplemento == 0) {
                importeTotal = (
                    Number((this.modelReserva.cant_habitaciones_individuales * Math.ceil(parseFloat(this.precio_ind))).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles * Math.ceil(parseFloat(this.precio_doble))).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * Math.ceil(parseFloat(this.precio_doble))).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_triples * Math.ceil(parseFloat(this.precio_triple))).toFixed(2))
                );
                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(this.precio_ind).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * this.precio_ind).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(this.precio_doble).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(this.precio_doble).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * this.precio_doble).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(this.precio_triple).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * this.precio_triple).toFixed(2)} €` : '');

                this.modelReserva.descripcion_importe_reserva = this.descripcionImporteReserva.replace(/<br>/g, '\n').replace(/<b>/g, '').replace(/<\/b>/g, '');
                return parseFloat(importeTotal).toFixed(2);
            }

            if (suplemento > 0 && nochesTotales == nochesConSuplemento) {
                const precioIndConSuplemento = Math.ceil(parseFloat(this.precio_ind) * factorSuplemento);
                const precioDobleConSuplemento = Math.ceil(parseFloat(this.precio_doble) * factorSuplemento);
                const precioTripleConSuplemento = Math.ceil(parseFloat(this.precio_triple) * factorSuplemento);

                importeTotal = (
                    Number((this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2))
                );

                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €<br>` : '');

                this.modelReserva.descripcion_importe_reserva = this.descripcionImporteReserva.replace(/<br>/g, '\n')
                    .replace(/<b>(Tarifas con Suplemento)<\/b>/g, '');

                return parseFloat(importeTotal).toFixed(2);
            }

            if (suplemento > 0 && nochesTotales > nochesConSuplemento) {
                const precioIndSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_ind) / nochesTotales);
                const precioDobleSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_doble) / nochesTotales);
                const precioTripleSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_triple) / nochesTotales);

                const precioIndConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_ind) * factorSuplemento) / nochesTotales);
                const precioDobleConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_doble) * factorSuplemento) / nochesTotales);
                const precioTripleConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_triple) * factorSuplemento) / nochesTotales);

                const precioIndConSuplemento = Math.ceil(precioIndSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioIndConSuplementoPorNoche * nochesConSuplemento);
                const precioDobleConSuplemento = Math.ceil(precioDobleSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioDobleConSuplementoPorNoche * nochesConSuplemento);
                const precioTripleConSuplemento = Math.ceil(precioTripleSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioTripleConSuplementoPorNoche * nochesConSuplemento);

                importeTotal = (
                    Number((this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2))
                );
                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioIndSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioIndConSuplementoPorNoche).toFixed(2)} €)<br><br>` : '') +

                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioDobleSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioDobleConSuplementoPorNoche).toFixed(2)} €)<br><br>` : '') +

                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioDobleSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioDobleConSuplementoPorNoche).toFixed(2)} €)<br><br>` : '') +

                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `(${nochesTotales - nochesConSuplemento} noches x ${parseFloat(precioTripleSinSuplementoPorNoche).toFixed(2)} €) (${nochesConSuplemento} noches x ${parseFloat(precioTripleConSuplementoPorNoche).toFixed(2)} €)<br>` : '') +

                    `<b>(Noches con suplemento: ${nochesConSuplemento} de ${nochesTotales})</b><br>`;

                this.modelReserva.descripcion_importe_reserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €<br>` : '') +

                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +

                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +

                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €<br>` : '');

                this.modelReserva.descripcion_importe_reserva = this.modelReserva.descripcion_importe_reserva.replace(/<br>/g, '\n');

                return parseFloat(importeTotal).toFixed(2);
            }


            /*

            if (this.camino.suplemento && this.camino.suplemento > 0 && nochesJulioAgosto > 0) {
               

                let precioSinSuplemento = (
                    this.modelReserva.cant_habitaciones_individuales * this.precio_ind +
                    this.modelReserva.cant_habitaciones_dobles * this.precio_doble +
                    this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble +
                    this.modelReserva.cant_habitaciones_triples * this.precio_triple
                );

                let precioSinSuplementoPorDia = (precioSinSuplemento / nochesTotales).toFixed(2);
                let precioConSuplemento = precioSinSuplemento + (precioSinSuplemento * this.camino.suplemento / 100);
                let precioConSuplementoPorDia = (precioConSuplemento / nochesTotales).toFixed(2);

                let importeTotalSinSuplemento = (precioSinSuplementoPorDia * (nochesTotales - nochesJulioAgosto)).toFixed(2);
                let importeTotalConSuplemento = (precioConSuplementoPorDia * nochesJulioAgosto).toFixed(2);

                importeTotal = (parseFloat(importeTotalSinSuplemento) + parseFloat(importeTotalConSuplemento)).toFixed(2);

                // Guardamos la descripción en una variable separada para no causar reactividad
                this.descripcionImporteReserva =
                    `Noches sin suplemento: ${nochesTotales - nochesJulioAgosto}<br>` +
                    `Noches con suplemento: ${nochesJulioAgosto}<br>` +
                    `Precio sin suplemento: ${precioSinSuplemento} €<br>` +
                    `Precio con suplemento: ${precioConSuplemento} €<br>` +
                    `Precio sin suplemento por día: (${precioSinSuplemento} € / ${nochesTotales} noches) = ${precioSinSuplementoPorDia} €<br>` +
                    `Precio con suplemento por día: (${precioConSuplemento} € / ${nochesTotales} noches) = ${precioConSuplementoPorDia} €<br>` +
                    `Importe total sin suplemento: (${precioSinSuplementoPorDia} € x ${nochesTotales - nochesJulioAgosto} noches) = ${importeTotalSinSuplemento} €<br>` +
                    `Importe total con suplemento: (${precioConSuplementoPorDia} € x ${nochesJulioAgosto} noches) = ${importeTotalConSuplemento} €<br>` +
                    `Importe total: (${importeTotalSinSuplemento} € + ${importeTotalConSuplemento} €) = ${importeTotal} €`;

            } else {
                importeTotal = (
                    this.modelReserva.cant_habitaciones_individuales * this.precio_ind +
                    this.modelReserva.cant_habitaciones_dobles * this.precio_doble +
                    this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble +
                    this.modelReserva.cant_habitaciones_triples * this.precio_triple
                );

                // Guardamos la descripción en una variable separada
                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${this.precio_ind} € ..... ${this.modelReserva.cant_habitaciones_individuales * this.precio_ind} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${this.precio_doble} € ..... ${this.modelReserva.cant_habitaciones_dobles * this.precio_doble} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${this.precio_doble} € ..... ${this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${this.precio_triple} € ..... ${this.modelReserva.cant_habitaciones_triples * this.precio_triple} €` : '');
            }

            return parseFloat(Math.round(parseFloat(importeTotal))).toFixed(2);*/
        },

        importeComision() {
            return parseFloat(this.importeReserva * 15 / 100).toFixed(2);
        },

        importeNeto() {
            return parseFloat(this.importeReserva - this.importeComision).toFixed(2);
        },

        importeServicios() {

            return this.modelReserva.id != null ? this.modelReserva.importe_servicios:0;

            let importe = 0;
            this.descripcionImporteServicios = '';

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {

                    if (servicio.seleccionado && servicio.titulo !== 'Noche extra' && servicio.titulo !== 'Traslados extra' && servicio.titulo !== 'Servicios extra') {
                        let tarifa = parseFloat(this._calcularTarifaDeServicio(servicio)).toFixed(2);
                        if (servicio.x_reserva) {
                            importe += parseFloat(tarifa);
                        } else {
                            let importeServicio = parseFloat(tarifa) * this.modelReserva.cant_peregrinos;
                            importe += importeServicio;
                        }
                        this.descripcionImporteServicios += '• ' + this.getTituloServicio(servicio) + ' ..... ' + (this._calcularTarifaDeServicioWithPersona(servicio) == 0 ? ' - ' : this._calcularTarifaDeServicioWithPersona(servicio))
                            + ' €<br>';
                        this.descripcionImporteServicios += this._getSubtituloServicioWithPersona(servicio) + '<br>';
                    }
                }
            }
            this.descripcionImporteServicios += '<br>';

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {
                    if (servicio.titulo == 'Noche extra' && servicio.seleccionado) {
                        let importeEstaNocheExtra = 0;
                        for (let noche of this.nochesextras) {
                            importeEstaNocheExtra = 0;
                            if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                                importeEstaNocheExtra += (this.modelReserva.cant_habitaciones_individuales * noche.tarifa_ind);
                            }
                            if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                                importeEstaNocheExtra += ((this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) * noche.tarifa_doble);
                            }
                            if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                                importeEstaNocheExtra += (this.modelReserva.cant_habitaciones_triples * noche.tarifa_triple);
                            }
                            importe += importeEstaNocheExtra;
                            this.descripcionImporteServicios += '• Noche extra en ' + noche.localidad + ' ..... ' + Number(importeEstaNocheExtra).toFixed(2) + ' €<br>(';
                            if (this.modelReserva.cant_habitaciones_individuales > 0 && noche.tarifa_ind > 0)
                                this.descripcionImporteServicios += this.modelReserva.cant_habitaciones_individuales + ' Ind x ' + Number(noche.tarifa_ind).toFixed(2) + '€, ';
                            if ((this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0) && noche.tarifa_doble > 0)
                                this.descripcionImporteServicios += (this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) + ' Doble x ' + Number(noche.tarifa_doble).toFixed(2) + '€, ';
                            if (this.modelReserva.cant_habitaciones_triples > 0 && noche.tarifa_triple > 0)
                                this.descripcionImporteServicios += this.modelReserva.cant_habitaciones_triples + ' Triple x ' + Number(noche.tarifa_triple).toFixed(2) + '€';
                            this.descripcionImporteServicios += ')<br>';

                        }
                    }

                }
            }

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {
                    if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
                        let importeEstaNocheExtra = 0;
                        for (let trasladoextra of this.trasladosExtras) {
                            importe += Number(trasladoextra.importe);
                            this.descripcionImporteServicios += '• Traslado extra: ' + trasladoextra.descripcion + ' ..... ' + Number(trasladoextra.importe).toFixed(2) + ' €<br>';
                        }
                    }

                }
            }

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {
                    if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
                        let importeEstaNocheExtra = 0;
                        for (let servicioExtra of this.serviciosExtras) {
                            importe += Number(servicioExtra.importe);
                            this.descripcionImporteServicios += '• ' + servicioExtra.descripcion + ' ..... ' + Number(servicioExtra.importe).toFixed(2) + ' €<br>';
                        }
                    }

                }
            }

            return parseFloat(importe).toFixed(2);
        },

        importeTotal() {
            if (!this.esAgencia) {
                return Math.ceil(parseFloat(parseFloat(this.importeReserva) + parseFloat(this.importeServicios))).toFixed(2);
            } else {
                return parseFloat(parseFloat(this.importeReserva) + parseFloat(this.importeServicios)).toFixed(2);
            }
        },

        importeTotalNeto() {
            return parseFloat(parseFloat(this.importeTotal) - parseFloat(this.importeComision)).toFixed(2);
        },

        listadoPuntosFinales() {
            const res = [];
            if (this.camino) {
                for (let etapa of this.camino.etapas) {
                    res.push(etapa.final_punto.nombre);
                }
            }
            return res;
        },

    },
    created() {
        // Inicializar con España (primer país de la lista)
        this.codigoPaisSeleccionado = this.codigosPais.find(pais => pais.code === 'ES');
    },
    mounted() {
       
        this.language = this.$route.params.language.toLowerCase();
        this.$i18n.locale = this.language.toLowerCase();

        const hash = this.$route.params.hash;
        if (hash) {
            this._getReservaByHash(hash);
        } 

    },
    methods: {
        ...mapActions("caminos", ["getCamino", "getAgencia", "createReserva", "confirmarReserva", "getReservaByHash"]),


        async _getReservaByHash(hash) {
            const reserva = await this.getReservaByHash([hash]);


            this.modelReserva.id = reserva.id;
            this.modelReserva.codigo = reserva.codigo;
            this.modelReserva.fecha_inicio = reserva.fecha_inicio;
            this.modelReserva.fecha_llegada = reserva.fecha_llegada;
            this.modelReserva.cant_peregrinos = reserva.cant_peregrinos;
            this.modelReserva.cant_habitaciones_individuales = reserva.cant_habitaciones_individuales;
            this.modelReserva.cant_habitaciones_dobles = reserva.cant_habitaciones_dobles;
            this.modelReserva.cant_habitaciones_dobles_matrimoniales = reserva.cant_habitaciones_dobles_matrimoniales;
            this.modelReserva.cant_habitaciones_triples = reserva.cant_habitaciones_triples;
            this.modelReserva.importe_presupuestado = reserva.importe_presupuestado;
            this.modelReserva.importe_reserva = reserva.importe_reserva;
            this.modelReserva.importe_servicios = reserva.importe_servicios;
            this.modelReserva.descripcion_importe_presupuestado = reserva.descripcion_importe_presupuestado;
            this.modelReserva.descripcion_importe_reserva = reserva.descripcion_importe_reserva;

            this.modelReserva.camino = reserva.camino;

            
            this.modelReserva.cliente.nombre = reserva.cliente.nombre;
            this.modelReserva.cliente.apellidos = reserva.cliente.apellidos;
            this.modelReserva.cliente.telefono = reserva.cliente.telefono;
            this.modelReserva.cliente.email = reserva.cliente.email;

            this.importe_presupuestado = reserva.importe_presupuestado;
            this.descripcionImporteReserva = reserva.descripcion_importe_reserva;
            this.descripcionImporteServicios = reserva.descripcion_importe_servicios;
            
            


            
            this._pedirDatosPasajeros();
           /* this.pasajeros = Array.from({ length: this.reserva.cant_peregrinos }, () => ({
                nombre: '',
                apellidos: '',
                dni: '',
                edadNacimiento: '',
                direccion: '',
                poblacion: '',
                provincia: '',
                nacionalidad: '',
                cp: ''
            }));*/
        },

        async _getCamino(id) {
            const res = await this.getCamino([id]);
            if (this.camino) {
                this.serviciosNoIncluidos = this.camino.servicios
                    .filter(servicio => servicio.esta_habilitado && !servicio.esta_incluido)
                    .map(servicio => ({
                        ...servicio,
                        seleccionado: false
                    }));
            }
        },

        async _getAgencia(agencia) {
            const res = await this.getAgencia([agencia]);
            if (this.agencia && this.esAgencia) {
                // this.modelReserva.cliente.nombre = this.agencia.nombre;
                // this.modelReserva.cliente.telefono = this.agencia.telefono;
                // this.modelReserva.cliente.email = this.agencia.email;
                // this.modelReserva.cliente.aceptaPolitica = true;
                this.modelReserva.origen_id = this.agencia.id;
            }
        },

        isValidDocument(tipo, documento) {

            if (!documento || documento.trim() === '') return true;

            const tipoDocumento = String(tipo).toUpperCase();


            switch (tipoDocumento) {
                case 'DNI':
                    return /^[0-9]{8}[A-Z]$/.test(documento);
                case 'NIE':
                    return /^[XYZ][0-9]{7,8}[A-Z]$/.test(documento);
                case 'Pasaporte':
                    return /^[A-Za-z0-9\-]{5,20}$/.test(documento);
                default:
                    return true;
            }
        },

        _pedirDatosPasajeros() {
            this.pasajeros = [];
            this.pasajeros = Array.from({ length: this.modelReserva.cant_peregrinos }, () => ({
                nombre: '',
                primer_apellido: '',
                tipo_documento: 'DNI',
                documento: '',
            }));
            if (this.pasajeros.length > 0) {
                this.pasajeros[0].nombre = this.modelReserva.cliente.nombre;
                this.pasajeros[0].primer_apellido = this.modelReserva.cliente.apellidos;
            }
            this.step = 5;
        },

        _agregarNocheExtraVacia(localidad) {
            this.nochesextras.push({
                localidad: localidad,
                tarifa_ind: 0,
                tarifa_doble: 0,
                tarifa_triple: 0,
            });
            this._calcularFechaLlegada();
        },

        _agregarTrasladoExtraVacio() {
            this.trasladosExtras.push({
                descripcion: '',
                importe: 0,
            });
        },

        _agregarServicioExtraVacio() {
            this.serviciosExtras.push({
                descripcion: '',
                importe: 0,
            });
        },

        onEliminarNoche(index) {
            this.nochesextras.splice(index, 1);
            this._calcularFechaLlegada();
        },

        onEliminarTrasladoExtra(index) {
            this.trasladosExtras.splice(index, 1);
        },

        onEliminarServicioExtra(index) {
            this.serviciosExtras.splice(index, 1);
        },

        onServicioSeleccionado(servicio) {
            if (servicio.titulo == 'Noche extra') {
                if (servicio.seleccionado) {
                    if (this.nochesextras.length == 0) {
                        this._agregarNocheExtraVacia('');
                    }
                } else {
                    this.nochesextras = [];
                    this._calcularFechaLlegada();
                }
            }

            if (servicio.titulo == 'Traslados extra') {
                if (servicio.seleccionado) {
                    if (this.trasladosExtras.length == 0) {
                        this._agregarTrasladoExtraVacio();
                    }
                } else {
                    this.trasladosExtras = [];
                }
            }

            if (servicio.titulo == 'Servicios extra') {
                if (servicio.seleccionado) {
                    if (this.serviciosExtras.length == 0) {
                        this._agregarServicioExtraVacio();
                    }
                } else {
                    this.serviciosExtras = [];
                }
            }

            if (servicio.titulo.includes('Traslado privado')) {
                if (servicio.seleccionado) {
                  
                } else {
                    servicio.descripcion = '';
                    servicio.importe = 0;
                }
            }
        },

        _irAWebAlCamino() {
            if (this.language == 'en') {
                window.open(this.camino.link_web, '_blank');
            } else if (this.language == 'de') {
                window.open(this.camino.link_web, '_blank');
            } else {
                window.open(this.camino.link_web, '_blank');
            }
        },

        _irANuevoPresupuesto() {
            if (!this.admin) {
                this.$router.push({
                    name: 'central_agencias',
                    params: {
                        agencia: this.agencia.identificador,
                    }
                });
            } else {
                this.$router.push({ name: 'formularioInicial' });
            }
        },

        _cambiarStep(step) {
            this.step = step;
        },

        _emailValido(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        _enviarPresupuestoAAgencia() {
            if (this.esAgencia) {
                if (!this.modelReserva.cliente.email || this.modelReserva.cliente.email === this.agencia.email) {
                    return true;
                }
            }
            return false;
        },

        _enviarPresupuestoAlClienteFinal() {
            if (this.esAgencia) {
                if (this._emailValido(this.modelReserva.cliente.email) && this.modelReserva.cliente.email !== this.agencia.email) {
                    return true;
                }
            }
            return false;
        },

        _activadoEnvioDePresupuestoDesdeAgencia() {
            if (this.modelReserva.cliente.aceptaPolitica && this.esAgencia && (this._enviarPresupuestoAAgencia() || this._enviarPresupuestoAlClienteFinal())) {
                return true;
            }
            return false;
        },

        crearFechaLocal(fecha) {
            if (!fecha) return null;
            if (fecha instanceof Date) {
                return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
            }

            const fechaTexto = String(fecha).slice(0, 10);
            const [year, month, day] = fechaTexto.split('-').map(Number);

            if (year && month && day) {
                return new Date(year, month - 1, day);
            }

            const fechaParseada = new Date(fecha);
            return new Date(fechaParseada.getFullYear(), fechaParseada.getMonth(), fechaParseada.getDate());
        },

        obtenerTarifaActual() {
            if (!this.camino || !this.modelReserva.fecha_inicio) {
                return null;
            }

            return this.encontrarTarifaPorFecha(this.modelReserva.fecha_inicio);
        },

        obtenerSuplementoTarifa(tarifa = this.obtenerTarifaActual()) {
            const suplemento = Number(tarifa && tarifa.suplemento);
            return Number.isFinite(suplemento) && suplemento > 0 ? suplemento : 0;
        },

        calcularNochesConSuplemento(tarifa = this.obtenerTarifaActual()) {
            if (!this.modelReserva.fecha_inicio || !this.modelReserva.fecha_llegada || !tarifa) return 0;

            const suplemento = this.obtenerSuplementoTarifa(tarifa);
            if (suplemento <= 0 || !tarifa.suplemento_fecha_desde || !tarifa.suplemento_fecha_hasta) return 0;

            let noches = 0;
            let fechaActual = this.crearFechaLocal(this.modelReserva.fecha_inicio);
            const fechaLlegada = this.crearFechaLocal(this.modelReserva.fecha_llegada);
            const fechaSuplementoDesde = this.crearFechaLocal(tarifa.suplemento_fecha_desde);
            const fechaSuplementoHasta = this.crearFechaLocal(tarifa.suplemento_fecha_hasta);

            while (fechaActual < fechaLlegada) {
                if (fechaActual >= fechaSuplementoDesde && fechaActual <= fechaSuplementoHasta) {
                    noches++;
                }
                fechaActual.setDate(fechaActual.getDate() + 1);
            }

            return noches;
        },

        calcularNochesTotales() {
            if (!this.modelReserva.fecha_inicio || !this.modelReserva.fecha_llegada) return 0;

            const inicio = this.crearFechaLocal(this.modelReserva.fecha_inicio);
            const llegada = this.crearFechaLocal(this.modelReserva.fecha_llegada);
            const diferencia = llegada.getTime() - inicio.getTime();
            return Math.ceil(diferencia / (1000 * 3600 * 24));
        },





        _getSubtitulo(servicio) {
            if (servicio) {
                if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                    return this.$t('mensajes.servicios.pendiente_de_tarifa')
                }
                if (servicio.x_reserva == 1) {
                    return this.$t('mensajes.servicios.subtitulo_desde', { tarifa: this._calcularTarifaDeServicio(servicio) });
                }

                if (servicio.x_persona == 1) {
                    return this.$t('mensajes.servicios.subtitulo_por_persona', { tarifa: this._calcularTarifaDeServicio(servicio) });
                }

            }
            return '';
        },

        _getSubtituloServicioWithPersona(servicio) {
            if (servicio) {

                /*if (this.admin && servicio.titulo.includes('Traslado privado a')) {
                    return '';
                }*/

                if (servicio.titulo.includes('Traslado privado')) {
                    if (servicio.descripcion === '' || servicio.descripcion === null) {
                        return '';
                    }
                    return '(' + servicio.descripcion + ')';
                }

                if (servicio.titulo == 'Noche extra' && servicio.seleccionado) {
                    var result = '';

                    for (let noche of this.nochesextras) {
                        if (noche.localidad != '') {
                            result += '• Noche extra en ' + noche.localidad + '\n';
                            if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                                result += '(' + this.modelReserva.cant_habitaciones_individuales + ' Ind x ' + noche.tarifa_ind + '€)';
                            }
                            if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                                result += '(' + (this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) + ' Doble x ' + noche.tarifa_doble + '€)';
                            }
                            if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                                result += '(' + this.modelReserva.cant_habitaciones_triples + ' Triple x ' + noche.tarifa_triple + '€)';
                            }
                            result += '.....' + (Number(noche.tarifa_ind * this.modelReserva.cant_habitaciones_individuales +
                                noche.tarifa_doble * this.modelReserva.cant_habitaciones_dobles +
                                noche.tarifa_doble * this.modelReserva.cant_habitaciones_dobles_matrimoniales +
                                noche.tarifa_triple * this.modelReserva.cant_habitaciones_triples).toFixed(2)) + ' €\n';
                        }
                    }
                    return result;
                }

                if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
                    var result = '';

                    for (let traslado of this.trasladosExtras) {
                        if (traslado.descripcion != '') {
                            result += '• Traslado extra: ' + traslado.descripcion + ' ..... ' + Number(traslado.importe).toFixed(2) + '\n';
                        }
                    }
                    return result;
                }

                if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
                    var result = '';

                    for (let servicioExtra of this.serviciosExtras) {
                        if (servicioExtra.descripcion != '') {
                            result += '• ' + servicioExtra.descripcion + ' ..... ' + Number(servicioExtra.importe).toFixed(2) + '\n';
                        }
                    }
                    return result;
                }



                if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                    return this.$t('mensajes.servicios.pendiente_de_tarifa')
                }
                if (servicio.x_reserva == 1) {
                    return "(" + this._calcularTarifaDeServicioWithPersona(servicio) + "€)";
                }

                if (servicio.x_persona == 1) {
                    return this.$t('mensajes.servicios.subtitulo_por_persona_con_persona', { tarifa: this._calcularTarifaDeServicio(servicio), personas: this.modelReserva.cant_peregrinos });
                }

            }
            return '';
        },

        _calcularTarifaDeServicio(servicio) {
            if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
                return servicio.importe;
            }

            if (!servicio || !servicio.tarifa) {
                return 0;
            }

            if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {

                return 0;
            }

            let tarifa = parseFloat(servicio.tarifa);

            if (servicio.x_reserva) {
                if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
                    return parseFloat(tarifa);
                }
            }

            if (servicio.x_noche) {
                tarifa = tarifa * this.camino.noches;
            }
            if (servicio.x_etapa) {
                tarifa = tarifa * (this.camino.noches - 1);
            }

            return parseFloat(tarifa);
        },

        _calcularTarifaDeServicioWithPersona(servicio) {

            if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
                return Number(servicio.importe).toFixed(2);
            }

            if (servicio.titulo == 'Noche extra' && servicio.seleccionado) {
                var res = 0;

                for (let noche of this.nochesextras) {
                    if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                        res = res + (this.modelReserva.cant_habitaciones_individuales * noche.tarifa_ind);
                    }
                    if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                        res = res + ((this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) * noche.tarifa_doble);
                    }
                    if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                        res = res + (this.modelReserva.cant_habitaciones_triples * noche.tarifa_triple);
                    }
                }
                return res;
            }

            if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
                var res = 0;

                for (let traslado of this.trasladosExtras) {
                    if (traslado.importe > 0) {
                        res = res + Number(traslado.importe);
                    }
                }
                return res;
            }

            if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
                var res = 0;

                for (let servicioExtra of this.serviciosExtras) {
                    if (servicioExtra.importe > 0) {
                        res = res + Number(servicioExtra.importe);
                    }
                }
                return res;
            }

            if (!servicio || !servicio.tarifa) {
                return 0;
            }

            if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                return 0;
            }


            let tarifa = this._calcularTarifaDeServicio(servicio);



            let result = 0;

            if (servicio.x_reserva) {
                if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
                    return parseFloat(tarifa);
                }
            }

            if (servicio.x_persona) {
                result = tarifa * this.modelReserva.cant_peregrinos;
            }


            return Number(result).toFixed(2);
        },

        formatearFecha(fecha) {
            if (!fecha) return ''
            const caption_inicio = new Date(fecha).toLocaleDateString(this.$i18n.locale, {
                day: '2-digit',
                month: 'long'
            });

            const caption_llegada = new Date(this.modelReserva.fecha_llegada).toLocaleDateString(this.$i18n.locale, {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            });
            return caption_inicio + ' - ' + caption_llegada;
        },

        _changeFechaInicio() {
            this._calcularFechaLlegada();
        },

        _setCantidadPeregrinos(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_peregrinos++;
            } else if (operacion === '-' && this.modelReserva.cant_peregrinos > 0) {
                this.modelReserva.cant_peregrinos--;
            }
        },

        _setCantidadHabitacionesIndividuales(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_individuales++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_individuales > 0) {
                this.modelReserva.cant_habitaciones_individuales--;
            }
            this._calcularCantidadPeregrinos();
        },

        getTituloServicio(servicio) {
            if (!this.language) {
                return servicio.titulo; // Retornamos el título por defecto
            }

            if (this.language.toLowerCase() === 'es') {
                return servicio.titulo;
            } else if (this.language.toLowerCase() === 'en') {
                return servicio.titulo_EN;
            } else if (this.language.toLowerCase() === 'de') {
                return servicio.titulo_DE;
            }
            return servicio.titulo;
        },

        getTituloCamino(camino) {
            if (this.language.toLowerCase() === 'es') {
                return camino.titulo;
            } else if (this.language.toLowerCase() === 'en') {
                return camino.titulo_EN;
            } else if (this.language.toLowerCase() === 'de') {
                return camino.titulo_DE;
            }
            return camino.titulo;
        },

        _setCantidadHabitacionesDobles(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_dobles++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_dobles > 0) {
                this.modelReserva.cant_habitaciones_dobles--;
            }
            this._calcularCantidadPeregrinos();
        },

        _setCantidadHabitacionesDoblesMatrimoniales(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_dobles_matrimoniales++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0) {
                this.modelReserva.cant_habitaciones_dobles_matrimoniales--;
            }
            this._calcularCantidadPeregrinos();
        },

        _setCantidadHabitacionesTriples(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_triples++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_triples > 0) {
                this.modelReserva.cant_habitaciones_triples--;
            }
            this._calcularCantidadPeregrinos();
        },


        _calcularFechaLlegada() {
            if (this.camino != null && this.camino.etapas.length > 0) {
                this.modelReserva.fecha_llegada = new Date(this.modelReserva.fecha_inicio);
                this.modelReserva.fecha_llegada.setDate(this.modelReserva.fecha_llegada.getDate() + (this.camino.etapas.length) + this.nochesextras.length);
                this.modelReserva.fecha_llegada = this.modelReserva.fecha_llegada.toISOString().slice(0, 10);

                this.actualizarTarifasCamino();
            }
        },

        actualizarTarifasCamino() {
            if (this.camino != null && this.modelReserva.fecha_inicio != null) {
                const tarifaEncontrada = this.encontrarTarifaPorFecha(this.modelReserva.fecha_inicio);

                if (tarifaEncontrada) {
                    this.precio_ind = tarifaEncontrada.precio_ind;
                    this.precio_doble = tarifaEncontrada.precio_doble;
                    this.precio_triple = tarifaEncontrada.precio_triple;
                }
            }
        },


        encontrarTarifaPorFecha(fechaInicio) {
            if (!this.camino || !this.camino.tarifas || !Array.isArray(this.camino.tarifas)) {
                return null;
            }
            const fechaInicioDate = this.crearFechaLocal(fechaInicio);
            const tarifaEncontrada = this.camino.tarifas.find(tarifa => {
                const fechaDesde = this.crearFechaLocal(tarifa.fecha_desde);
                const fechaHasta = this.crearFechaLocal(tarifa.fecha_hasta);
                return fechaInicioDate >= fechaDesde && fechaInicioDate <= fechaHasta;
            });
            return tarifaEncontrada || null;
        },



        _calcularCantidadPeregrinos() {
            this.modelReserva.cant_peregrinos =
                this.modelReserva.cant_habitaciones_individuales * 1 +
                this.modelReserva.cant_habitaciones_dobles * 2 +
                this.modelReserva.cant_habitaciones_dobles_matrimoniales * 2 +
                this.modelReserva.cant_habitaciones_triples * 3;
        },

        _recibirPresupuesto() {
            this.step = 4;
            if (this.esAgencia) {
                this.modelReserva.cliente.telefono = this.agencia.telefono;
                if (!this.modelReserva.cliente.nombre) {
                    this.modelReserva.cliente.nombre = this.agencia.nombre;
                }
                if (!this.modelReserva.cliente.apellidos) {
                    this.modelReserva.cliente.apellidos = "";
                }
                if (!this.modelReserva.cliente.email) {
                    this.modelReserva.cliente.email = this.agencia.email;
                }
            }
            this.loadingEnviandoPresupuesto = true;
            this._createReserva();

        },

        actualizarTienePendientes(serviciosSeleccionados) {
            this.modelReserva.tienePendientes = false;
            //if (!this.admin) {

            const serviciosPendientesTarifa = serviciosSeleccionados.filter(servicio =>
                (servicio.titulo.includes('Traslado') ||
                 servicio.titulo.includes('Noche extra') ||
                 servicio.titulo.includes('Servicios extra')) && 
                 (servicio.importe !== undefined && parseFloat(servicio.importe) == 0)
            );
            if (serviciosPendientesTarifa.length > 0) {
                this.modelReserva.tienePendientes = true;
            }
            //   }
        },

        async _createReserva() {
            this.modelReserva.importe_presupuestado = this.importeTotal;
            this.modelReserva.importe_reserva = this.importeReserva;
            this.modelReserva.importe_servicios = this.importeServicios;


            this.generateDescriptionImportePresupuestado();
            if (!this.esAgencia) {
                this.modelReserva.cliente.telefono = this.codigoPaisSeleccionado.dial_code + this.modelReserva.cliente.telefono;
            }

            const serviciosSeleccionados = this.serviciosNoIncluidos.filter(servicio => servicio.seleccionado).map(servicio => ({
                servicio_id: servicio.id,
                titulo: this.getTituloServicio(servicio),
                descripcion: this._getSubtituloServicioWithPersona(servicio),
                importe: this._calcularTarifaDeServicioWithPersona(servicio)
            }));

            this.actualizarTienePendientes(serviciosSeleccionados);

            const response = await this.createReserva([this.camino, this.modelReserva, serviciosSeleccionados, this.language.toUpperCase()]);
              if (!this.esAgencia) {
                  this.modelReserva.cliente.telefono = this.modelReserva.cliente.telefono.replace(this.codigoPaisSeleccionado.dial_code, '');
              }
            this.loadingEnviandoPresupuesto = false;
        },

        async _enviarConfirmacionReserva() {
            this.step = 4;
            
            this.loadingEnviandoPresupuesto = true;
            await new Promise(resolve => setTimeout(resolve, 3000));
            this.loadingEnviandoPresupuesto = false;

          //  this._confirmarReserva();
        },

        generateDescriptionImportePresupuestado() {
            //  this.modelReserva.descripcion_importe_reserva = this.descripcionImporteReserva.replace(/<br>/g, '\n').replace(/<b>/g, '').replace(/<\/b>/g, '');
            this.modelReserva.descripcion_importe_servicios = this.descripcionImporteServicios.replace(/<br>/g, '\n');
            if (!this.esAgencia) {

                this.modelReserva.descripcion_importe_presupuestado = this.$t('mensajes.datos_reserva.importe_reserva') + this.importeReserva + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.descripcion_importe_reserva + '\n\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.servicios_agregados') + this.importeServicios + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.descripcion_importe_servicios + '\n\n';

                /*for (let servicio of this.serviciosNoIncluidos) {
                    if (servicio.seleccionado) {

                        this.modelReserva.descripcion_importe_presupuestado += this.getTituloServicio(servicio) + ' ' + this._getSubtituloServicioWithPersona(servicio) + ': ';

                        if (this._calcularTarifaDeServicioWithPersona(servicio) == 0) {
                            this.modelReserva.descripcion_importe_presupuestado += ' - ';
                        } else {
                            this.modelReserva.descripcion_importe_presupuestado += this._calcularTarifaDeServicioWithPersona(servicio) + ' €\n';
                        }

                    }
                }*/
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.importe_total') + this.importeTotal + ' €';
            } else {
                this.modelReserva.descripcion_importe_presupuestado = this.$t('mensajes.datos_reserva.importe_reserva') + ' (PVP)' + this.importeReserva + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.comision_agencia') + this.importeComision + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.importe_neto_agencia') + this.importeNeto + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.descripcionImporteReserva.replace(/<br>/g, '') + '\n\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.servicios_agregados') + ' (Neto)' + this.importeServicios + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.descripcionImporteServicios.replace(/<br>/g, '\n') + '\n\n';



                /*  for (let servicio of this.serviciosNoIncluidos) {
                      if (servicio.seleccionado) {
                          this.modelReserva.descripcion_importe_presupuestado += this.getTituloServicio(servicio) + ' ' + this._getSubtituloServicioWithPersona(servicio) + ': ';
  
                          if (this._calcularTarifaDeServicioWithPersona(servicio) == 0) {
                              this.modelReserva.descripcion_importe_presupuestado += ' - ';
                          } else {
                              this.modelReserva.descripcion_importe_presupuestado += this._calcularTarifaDeServicioWithPersona(servicio) + ' €\n';
                          }
  
                      }
                  }*/

                this.modelReserva.descripcion_importe_presupuestado += '\n' + this.$t('mensajes.datos_reserva.importe_total') + ' (PVP)' + this.importeTotal + ' €';
                this.modelReserva.descripcion_importe_presupuestado += '\n' + this.$t('mensajes.datos_reserva.importe_total') + ' (Neto)' + this.importeTotalNeto + ' €';
            }



        },

        async _confirmarReserva() {
            this.modelReserva.importe_presupuestado = this.importeTotal;
            this.modelReserva.importe_reserva = this.importeReserva;
            this.modelReserva.importe_servicios = this.importeServicios;
            this.generateDescriptionImportePresupuestado();
            
            const serviciosSeleccionados = this.serviciosNoIncluidos.filter(servicio => servicio.seleccionado).map(servicio => ({
                servicio_id: servicio.id,
                titulo: this.getTituloServicio(servicio),
                descripcion: this._getSubtituloServicioWithPersona(servicio),
                importe: this._calcularTarifaDeServicioWithPersona(servicio)
            }));

            const response = await this.confirmarReserva([this.camino, this.modelReserva, serviciosSeleccionados, this.pasajeros, this.language.toUpperCase()]);
            if (!this.esAgencia) {
                this.modelReserva.cliente.telefono = this.modelReserva.cliente.telefono.replace(this.codigoPaisSeleccionado.dial_code, '');
            }
            this.loadingEnviandoPresupuesto = false;
        },


        _Siguiente() {
            this.step++;
            if (this.step > 3) {
                this.step = 1;
            }

        },

        _Atras() {
            this.step--;
            if (this.step < 1) {
                this.step = 3;
            }
        },
    },
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: 4px solid #FF9C00 !important;
    border-radius: 15px !important;
}

.flying-document-container {
    position: relative;
    height: 150px;
    width: 100%;
    overflow: hidden;
}

.flying-document {
    position: relative;
    animation: fly 2s infinite ease-in-out;
}

.wind-line {
    position: absolute;
    height: 2px;
    background: #FF9C00;
    opacity: 0.6;
    animation: wind 2s infinite ease-in-out;
}

.wind-line-1 {
    width: 50px;
    top: 40%;
    left: 30%;
}

.wind-line-2 {
    width: 30px;
    top: 50%;
    left: 45%;
    animation-delay: 0.2s;
}

.wind-line-3 {
    width: 40px;
    top: 60%;
    left: 35%;
    animation-delay: 0.4s;
}


@keyframes fly {
    0% {
        transform: translateX(-100%) translateY(20px) rotate(0deg);
    }

    50% {
        transform: translateX(0) translateY(0px) rotate(5deg);
    }

    100% {
        transform: translateX(100%) translateY(20px) rotate(0deg);
    }
}

@keyframes wind {
    0% {
        transform: translateX(-100%) scaleX(0.5);
        opacity: 0;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        transform: translateX(100%) scaleX(1);
        opacity: 0;
    }
}

.pulse-text {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card.v-leave-active {
    animation: slideOut 0.5s ease-in;
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card-up.v-leave-active {
    animation: slideOutDown 0.5s ease-in;
}

@keyframes slideOutDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}
</style>
